<template>
    <div class="bonusomat-board-rules">
        Minimální sázka u všech úkolů je
        <span class="bonusomat-board-rules__amount" v-html="minBetAmountFormated"></span>, s výjimkou úkolu Hry Live,
        kde činí <span class="bonusomat-board-rules__amount" v-html="minBetAmountLiveGamesFormated"></span>.
        <br />
        Kompletní pravidla
        <MobileAppLink
            :href="rulesLik"
            event-name="openPdf"
            :event-argument="rulesLik"
            :open-in-new-tab="true"
            class="bonusomat-board-rules__link"
            >zde</MobileAppLink
        >.
    </div>
</template>

<script setup lang="ts">
import { StringUtils } from "@sazka/utils/string-utils";
import { computed } from "vue";
import MobileAppLink from "@sazka/mobile-apps/components/mobile-app-link.vue";

const props = defineProps<{
    minBetAmount: number;
    rulesLik: string;
}>();

const minBetAmountFormated = computed(() => StringUtils.formatCurrency(props.minBetAmount));
const minBetAmountLiveGamesFormated = StringUtils.formatCurrency(10);
</script>
